<template>
  <div>
    <img src="../assets/icon28.png" alt="" />
    <p class="fs30 textc">恭喜您，成功实名认证及投顾电子合同签署！</p>
    <p class="fs26 color666 textc" style="margin-top: 0.47rem">
      请联系您的投顾顾问开始您的理财~
    </p>
    <div class="btn" @click="next">下载神光启明星APP</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    this.OrderInfo = JSON.parse(localStorage.getItem("OrderInfo"));
  },
  methods: {
    next(){
      window.location.href=this.OrderInfo.url
    }
  },
};
</script>

<style lang="less" scoped>
img {
  width: 3.01rem;
  height: 3.01rem;
  margin-top: 1.65rem;
  margin-left: 2.18rem;
  margin-bottom: 1.63rem;
}
.btn {
  width: 4.2rem;
  height: 0.8rem;
  background: linear-gradient(9deg, #3984fb 0%, #3592fc 100%);
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1.44rem 1.65rem 1.86rem 1.65rem;
  font-size: 0.3rem;
  color: #ffffff;
}
</style>